import React, { useState, useEffect } from "react";
import { Table, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import SponsorRegistrationP1 from "../../../Sponsor/Registration/components/Page1";
import MBAFormJ from "./MBAFormJ";
import { getOneContractFarmingDetails } from "../../../../auth/services/privateapicalling";

interface FormKProps {
  applicationId: any;
  applicationDataInfo:any;
  remarks:any;
  loading:any;
}

const DashboardFormK = ({ applicationId,applicationDataInfo, remarks, loading }: FormKProps) => {
  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  // const [applicationDataInfo, setApplicationDataInfo] = useState<any>(null);
  // const [remarks, setRemarks] = useState("");
  // const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const [district, setDistrict] = useState([]);

  // Fetch application data


    // Calculate districts when applicationDataInfo changes
    useEffect(() => {
      if (
        applicationDataInfo &&
        Array.isArray(applicationDataInfo?.commodityRegsBySponsorRegNo) &&
        applicationDataInfo?.commodityRegsBySponsorRegNo.length > 0
      ) {
        type Commodity = {
          district_id: string;
          departmentDetailsByApmc?: { District?: string };
        };
  
        const commodities: Commodity[] = applicationDataInfo?.commodityRegsBySponsorRegNo;
    
  
        const uniqueDistricts = Array.from(
          new Set(commodities.map((c: Commodity) => c.district_id))
        );
       
  
        const districtData = uniqueDistricts.map((distId) => {
          const commodity = commodities.find((c: Commodity) => c.district_id === distId);
          return {
            value: distId,
            label: commodity?.departmentDetailsByApmc?.District || "",
          };
        });
        setDistrict(districtData);
  
      }
    }, [applicationDataInfo]);
    


  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "Sno",
      width: 80,
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", width: "130px" }}>
          Name and address of Applicant
        </div>
      ),
      dataIndex: "nameAndAddress",
      width: 100,
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", width: "130px" }}>
          Date of receipt of Application
        </div>
      ),
      dataIndex: "date",
      width: 150,
    },
    {
      title: "Registration fee Rs.",
      dataIndex: "registrationFee",
      width: 150,
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", width: "150px" }}>
          District(s) for which the Registration is granted
        </div>
      ),
      dataIndex: "districts",
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", width: "150px" }}>
          Period for which Registration is granted
        </div>
      ),
      dataIndex: "registrationPeriod",
      width: 180,
    },
    {
      title: (
        <div style={{ whiteSpace: "normal", width: "130px" }}>
          No. and date of issue of registration
        </div>
      ),
      dataIndex: "registrationNumber",
    },
    {
      title: "Signature",
      dataIndex: "signature",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
    },
  ];

  // const data = [
  //   {
  //     key: "1",
  //     Sno: "1",
  //     nameAndAddress: (
  //       <div style={{ whiteSpace: "normal", width: "130px" }}>
  //         Priyansh Rana and Bhavnagar
  //       </div>
  //     ),
  //     date: "16-10-2012",
  //     registrationFee: "5000",
  //     districts: "Bhavnagar",
  //     registrationPeriod: "01-01-2025 to 31-12-2025",
  //     registrationNumber: "REG-2025-001 (20-09-2025)",
  //     signature: "Signed",
  //     remarks: "Approved",
  //   },
  // ];

  return (
    <>
      <div>
        <div className="m-3 m-md-4 m-lg-5">
          <div className="table-responsive">
            <div
              id="table"
              className="w-100 overflow-hidden border bg-white border-secondary rounded"
              style={{ minWidth: "900px" }}
            >
              {/* Header */}
              <div
                id="head"
                className="d-flex w-100 rounded-top border-bottom border-secondary"
                style={{ backgroundColor: "#CCE3FF" }}
              >
                <div className="col-6 d-flex text-center">
                  <h4 className="col-1 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    Sr No.
                  </h4>
                 
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    Applicant Name
                  </h4>
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    Address of Applicant
                  </h4>
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    Date of receipt of Application
                  </h4>
                  <h4 className="col-2 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 0.9rem)" }}>
                    Registration fee Rs.
                  </h4>
                  
                </div>
                <div className="col-6 d-flex text-center">
                  
                  <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    District(s) for which the Registration is granted
                  </h4>
                   <h4 className="col-2 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 0.9rem)" }}>
                    Registration No.
                  </h4>
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    Period for which Registration is granted
                  </h4>
                  
                  <h4 className="col-3 p-2 justify-content-center d-flex align-items-center" style={{ fontSize: "clamp(0.7rem, 1.5vw, 1rem)" }}>
                    Date of issue of registration
                  </h4>
                </div>
              </div>
              {/* Body */}
              <div
                id="head"
                className="d-flex w-100 rounded-top"
              >
                <div className="col-6 d-flex text-center">
                  <div className="col-1 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    1
                  </div>
                  
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    {applicationDataInfo?.Sponsor_Name || ""}
                  </div>
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    {applicationDataInfo?.Sponsor_Address || ""}
                  </div>
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    {applicationDataInfo?.createdAt || ""}
                  </div>
                  <div className="col-2 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    Rs. {applicationDataInfo?.Registration_Fee || ""}
                  </div>
                  
                </div>
                <div className="col-6 d-flex text-center">
                  
                  <div className="col-4 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    {district.map((dist, index) => (
                      <span key={dist.value}>
                        {dist.label}
                        {index < district.length - 1 && " ,"}
                      </span>
                    ))}
                  </div>
                  <div className="col-2 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                     {applicationDataInfo?.Sponsor_Registration_No || ""}
                  </div>
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center border-secondary border-end">
                    {applicationDataInfo?.Sponsor_Reg_Year || ""} Years
                  </div>
                  <div className="col-3 p-2 justify-content-center d-flex align-items-center">
                     {applicationDataInfo?.Sponsor_Reg_From || ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {loading ? (
              <div className="text-center p-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <MBAFormJ applicationId={applicationId} applicationDataInfo={applicationDataInfo} valCalledIn={"formK"} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardFormK;